import Vue from "vue";
import serviceInstance from "../service/service";
const service = {
  install(Vue, options) {
    Vue.prototype.$service = serviceInstance;
  },
};

Vue.use(service);
